module.exports = __webpack_public_path__ + "media/src/images/progress/dentals_4-f2d96aa7f8b2c7bd2825dc22b218db21.jpg";